import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchIncidents,
  resetStateIncidents,
} from "../../app/slices/incidentsSlice";
import LoadingContainer from "../../components/LoadingContainer/LoadingContainer";
import ErrorContainer from "../../components/ErrorContainer/ErrorContainer";
import AppDataTable from "../../components/AppDataTable/appDataTable";
import UpdateIncidentDialog from "./UpdateIncidentDialog";
import moment from "moment";
import { dateFormat } from "../../app/utils";

const IncidentManagement = () => {
  const { data, status, error } = useSelector(({ incidents }) => incidents.get);
  const [list, setList] = useState(null);

  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [method, setMethod] = useState("ADD");
  const [selectedIncident, setSelectedIncident] = useState(null);
  const dispatch = useDispatch();

  const columns = [
    {
      name: "created_date",
      label: "Date Submitted",
    },
    {
      name: "incident_date_alt",
      label: "Incident Date",
    },
    {
      name: "category",
      label: "Category",
    },
    {
      name: "tlp_status",
      label: "TLP Status",
      options: {
        align: "center",
      },
    },
    {
      name: "description_alt",
      label: "Description",
    },
    {
      name: "submitted_by",
      label: "Submitted By",
    },
    {
      name: "institution_name",
      label: "Institution",
    },
    {
      name: "status",
      label: "Incident Status",
      options: {
        align: "center",
      },
    },
  ];

  //use effects
  useEffect(() => {
    loadResources();
    return () => {
      dispatch(resetStateIncidents());
    };
  }, []);

  useEffect(() => {
    if (data?.length > 0) {
      let _list = [];
      data?.forEach((row) => {
        _list.push({
          ...row,
          created_date: moment(row?.created_date).format(dateFormat),
          incident_date_alt: moment(row?.incident_date).format(dateFormat),
          description_alt:
            row?.description?.length > 60
              ? `${row?.description?.substring(0, 59)}...`
              : row?.description,
        });
      });
      setList(_list);
    } else {
      setList([]);
    }
  }, [data]);

  //methods
  const loadResources = () => {
    dispatch(resetStateIncidents());
    dispatch(fetchIncidents());
  };

  //builders
  return (
    <>
      <div className="app-padding mt-20 mb-50">
        {status === "idle" && list && (
          <AppDataTable
            id="incidents-list"
            actions={[
              {
                action: "View",
                onClick: (item) => {
                  setMethod("VIEW");
                  setSelectedIncident({
                    ...item,
                    incidentId: item?.incident_id,
                    incidentCategory: item?.category,
                    incidentDate: moment(item?.incident_date).format(
                      "YYYY-MM-DD"
                    ),
                    contactEmail: item?.contact_email,
                    incidentRating: item?.rating,
                    incidentStatus: item?.status,
                    tlpStatus: item?.tlp_status,
                    incidentDescription: item?.description,
                    incidentLocation: item?.location,
                    causeOfIncident: item?.cause,
                    sourceOfDetection: JSON.parse(item?.detection_source),
                    financialImpact: item?.financial_impact,
                    nonFinancialImpact: JSON.parse(item?.non_financial_impact),
                    systemsImpacted: item?.impacted_softwares,
                    measuresTaken: item?.measures_taken,
                    lessonsLearned: item?.lessons_learned,
                    namesOfPersonsInvolved: item?.involved_persons,
                  });
                  setIsOpenDialog(true);
                },
              },
              {
                action: "Update",
                onClick: (item) => {
                  setMethod("UPDATE");
                  setSelectedIncident({
                    ...item,
                    incidentId: item?.incident_id,
                    incidentCategory: item?.category,
                    incidentDate: moment(item?.incident_date).format(
                      "YYYY-MM-DD"
                    ),
                    incidentRating: item?.rating,
                    incidentStatus: item?.status,
                    tlpStatus: item?.tlp_status,
                    incidentDescription: item?.description,
                    incidentLocation: item?.location,
                    causeOfIncident: item?.cause,
                    sourceOfDetection: JSON.parse(item?.detection_source),
                    financialImpact: item?.financial_impact,
                    nonFinancialImpact: JSON.parse(item?.non_financial_impact),
                    systemsImpacted: item?.impacted_softwares,
                    measuresTaken: item?.measures_taken,
                    lessonsLearned: item?.lessons_learned,
                    namesOfPersonsInvolved: item?.involved_persons,
                  });
                  setIsOpenDialog(true);
                },
              },
            ]}
            columns={columns}
            data={list}
            emptyMessage="No incidents found."
            rowsPerPageOptions={[10, 20, 50, 100]}
            downloadFileName={`TzFincert incidents ${moment().format(
              "DD-MMM-YYYY"
            )}`}
          />
        )}
        {status === "loading" && (
          <LoadingContainer message={"Loading incidents..."} />
        )}
        {status !== "loading" && error && (
          <ErrorContainer message={error?.message} onReload={loadResources} />
        )}
      </div>

      {/* Incident dialog */}
      {isOpenDialog && selectedIncident && (
        <UpdateIncidentDialog
          selectedIncident={selectedIncident}
          open={isOpenDialog}
          method={method}
          onClose={(refresh) => {
            setIsOpenDialog(false);
            if (refresh) {
              setSelectedIncident(null);
              if (refresh) {
                loadResources();
              }
            }
          }}
          title={method === "VIEW" ? "View Incident" : "Update Incident"}
        />
      )}
      {/* Incident dialog */}
    </>
  );
};

export default IncidentManagement;
